import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "ko", "vn", "cn", "jp", "ru", "th"],
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    debug: true,
    defaultNS: "common",
    fallbackLng: ["en"],
  });
export default i18n;

export function parseLocaleNumber(numberString) {
  // 먼저 숫자에서 천단위 구분자와 소수 구분자를 자동으로 감지
  const hasComma = numberString.includes(",");
  const hasDot = numberString.includes(".");

  let thousandSeparator = "";
  let decimalSeparator = "";

  // ,와 . 모두 있는 경우
  if (hasComma && hasDot) {
    // 마지막에 나오는 기호는 소수점 구분자로 사용
    if (numberString.lastIndexOf(",") > numberString.lastIndexOf(".")) {
      thousandSeparator = ".";
      decimalSeparator = ",";
    } else {
      thousandSeparator = ",";
      decimalSeparator = ".";
    }
  }
  // ,만 있는 경우
  else if (hasComma) {
    // , 뒤에 숫자가 세 자리 미만이면 소수 구분자로 사용
    if (numberString.split(",")[1] && numberString.split(",")[1].length < 3) {
      decimalSeparator = ",";
    } else {
      thousandSeparator = ",";
    }
  }
  // .만 있는 경우
  else if (hasDot) {
    // . 뒤에 숫자가 세 자리 미만이면 소수 구분자로 사용
    if (numberString.split(".")[1] && numberString.split(".")[1].length < 3) {
      decimalSeparator = ".";
    } else {
      thousandSeparator = ".";
    }
  }

  // 천단위 구분자 제거
  if (thousandSeparator) {
    numberString = numberString.split(thousandSeparator).join("");
  }

  // 소수 구분자를 '.'으로 변경
  if (decimalSeparator) {
    numberString = numberString.split(decimalSeparator).join(".");
  }

  const result = parseFloat(numberString);

  if (isNaN(result)) {
    throw new Error(`'${numberString}' is not a valid number.`);
  }

  return result;
}
